export default "__VITE_ASSET__B0aHGdS5__"